import {combineReducers, Reducer} from 'redux'
import { VideoFileState } from '@models/video-file'
import {VideoFilesActionTypes} from '@actions/video-file';




// Type-safe initialState!
export const initialState: VideoFileState = {
    allIds:[],
    byId:{},
    loading: false,
    count: 0
};


const byId = (state = initialState.byId, action) =>{
    switch(action.type){
        case VideoFilesActionTypes.FETCH_SUCCESS:{
            const{ data} = action.payload;
            return {
                ...data.reduce( (obj, video) => {
                    obj[video.id] = {
                        ...video,
                        is_fetched: false,
                        ...(state[video.id] || {}), //The data which fetch by id is more than data in Table
                    };
                    return obj;
                }, {})
            };
        }

        case VideoFilesActionTypes.CREATE_SUCCESS:{
            const video = action.payload;
            return {
                ...state,
                [video.id] : video
            };
        }

        case VideoFilesActionTypes.UPDATE_SUCCESS:{
            const video = action.payload;
            return {
                ...state,
                [video.id] : {
                    ...state[video.id],
                    ...video
                }
            };
        }

        case VideoFilesActionTypes.FETCH_ITEM_SUCCESS:{
            const video = action.payload;
            return {
                ...state,
                [video.id] : {
                    ...state[video.id],
                    ...video,
                    is_fetched: true
                },
            };
        }

        case VideoFilesActionTypes.DELETE_SUCCESS:
            return Object.keys(state)
                .filter(id => id !== action.payload.id)
                .reduce((result, current) => {
                    result[current] = state[current];
                    return result;
                }, {});


        default:
            return state;
    }
};


const allIds = (state = initialState.allIds, action) => {
    switch (action.type) {
        case VideoFilesActionTypes.FETCH_SUCCESS: {
            const {data} = action.payload;
            return data.map( item  => item.id);
        }

        case VideoFilesActionTypes.DELETE_SUCCESS:
            const deletedFormIndex = state.indexOf(action.payload.id);
            return [...state.slice(0, deletedFormIndex), ...state.slice(deletedFormIndex + 1)];

        case VideoFilesActionTypes.CREATE_SUCCESS:
            return [action.payload.id, ...state];

        default:
            return state
    }
};


const count = (state = initialState.count, action) => {
    switch (action.type) {
        case VideoFilesActionTypes.FETCH_SUCCESS: {
            const {meta} = action.payload;
            return meta.total_count;
        }

        case VideoFilesActionTypes.DELETE_SUCCESS:
            return state - 1;

        case VideoFilesActionTypes.CREATE_SUCCESS:
            return state + 1;


        default:
            return state
    }
};

const loading = (state = initialState.loading, action) => {
    switch (action.type) {
        case VideoFilesActionTypes.FETCH_REQUEST: {
            return true;
        }

        case VideoFilesActionTypes.FETCH_SUCCESS:
        case VideoFilesActionTypes.FETCH_ERROR:
            return false;

        default:
            return state
    }
};


const reducer: Reducer<VideoFileState> = combineReducers({
    byId,
    allIds,
    count,
    loading
});

export { reducer as videoFileReducer }




//Selectors
export const getVideoFilesList = videoFiles => videoFiles.allIds.map( id => videoFiles.byId[id]);

export const getVideoFileById = (videoFiles, id) => videoFiles.byId[id];